export default __webpack_public_path__ + "static/media/desktopnetworknotconnected.1d992857.png";